import { api } from '@/lib/api';
import type { IApiResponse, IPullRequest, IPullRequestActivityRow, IPullRequestListFilters } from '@skystone/shared';
import { buildListEndpoint, fetchAllPaginated } from './list-query';

export const pullRequestApi = {
  getAll: async (filters?: IPullRequestListFilters): Promise<IPullRequest[]> => {
    const url = buildListEndpoint('/pull-requests', [
      ['productId', filters?.productId],
      ['repositoryId', filters?.repositoryId],
      ['state', filters?.state],
      ['mergedOnly', filters?.mergedOnly],
      ['hasTest', filters?.hasTest],
      ['from', filters?.from],
      ['to', filters?.to],
      ['includeArchived', filters?.includeArchived],
      ['limit', filters?.limit],
      ['offset', filters?.offset],
    ]);
    const result = await api.get<IApiResponse<IPullRequest[]>>(url);
    return result.data;
  },

  getAllPaginated: async (filters?: Omit<IPullRequestListFilters, 'limit' | 'offset'>): Promise<IPullRequest[]> =>
    fetchAllPaginated<IPullRequest>('/pull-requests', [
      ['productId', filters?.productId],
      ['repositoryId', filters?.repositoryId],
      ['state', filters?.state],
      ['mergedOnly', filters?.mergedOnly],
      ['hasTest', filters?.hasTest],
      ['from', filters?.from],
      ['to', filters?.to],
      ['includeArchived', filters?.includeArchived],
    ]),

  getActivity: async (filters?: {
    from?: string;
    to?: string;
    mergedOnly?: boolean;
  }): Promise<IPullRequestActivityRow[]> => {
    const url = buildListEndpoint('/pull-requests/activity', [
      ['mergedOnly', filters?.mergedOnly],
      ['from', filters?.from],
      ['to', filters?.to],
    ]);
    const result = await api.get<IApiResponse<IPullRequestActivityRow[]>>(url);
    return result.data;
  },
};
